/* ============================================================
   ARKA EDGE — Custom interactions for Dawn theme
   Cursor, scroll reveal, dark-section detection
   ============================================================ */
(function () {
  'use strict';

  /* ── SCROLL REVEAL for .ae-reveal elements ───────────────── */
  (function initReveal() {
    function check() {
      var vh = window.innerHeight;
      document.querySelectorAll('.ae-reveal:not(.in)').forEach(function(el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.9 && r.bottom > 0) el.classList.add('in');
      });
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
    window.addEventListener('load', check);
  })();

})();
